import React from 'react'
import close_icon from '../../assets/images/icons/close-icon.jpeg'




const NotificationMessage = (props)=>{


    return(
        <div 
            className="notification-message-ctn mb-4" 
            style={props.style}>   
            <div className="notification-text">
                <span style={{color: 'red'}}>{props.signinStatus}</span>
            </div>
            <div className="notification-icon" style={{cursor: 'pointer'}} onClick={props.handleCloseNotificationMessage}>
                <img src={close_icon} alt="close-icon" style={{width: 30}}/>
            </div>
        </div>
    )
}

export default NotificationMessage